var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "banquet-chat" }, [
    _c("div", {
      staticClass: "ui vertical top loader",
      class: { active: _vm.getBanquetForm.waiting },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "ui stackable grid" }, [
      _c("div", { staticClass: "eight wide column chat-column" }, [
        _c(
          "div",
          { staticClass: "chatItemContainer" },
          _vm._l(_vm.comments, function (comment) {
            return _c("div", { key: comment.id, staticClass: "comment" }, [
              comment.is_own && (comment.text || comment.attachment)
                ? _c("div", { staticClass: "chatItem" }, [
                    _c(
                      "div",
                      { staticClass: "chatItem__talk chatItem__talk--self" },
                      [
                        _c(
                          "div",
                          { staticClass: "chatItem__talkMainContainer" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "chatItem__balloon chatItem__balloon--self",
                              },
                              [
                                comment.text
                                  ? _c("div", {
                                      staticClass: "chatItem__text linebreak",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$options.filters.urlize(
                                            comment.text
                                          )
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                comment.attachment
                                  ? _c(
                                      "div",
                                      { staticClass: "chatItem__text" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: comment.attachment.urls
                                                .original,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                comment.attachment
                                                  .original_file_name
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "chatItem__metaContainer chatItem__metaContainer--self",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteComment(comment)
                                      },
                                    },
                                  },
                                  [_vm._v("削除する")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "chatItem__metaContainer chatItem__metaContainer--self",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: comment.read,
                                        expression: "comment.read",
                                      },
                                    ],
                                    staticClass: "chatItem__readStatus",
                                  },
                                  [_vm._v("既読")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "chatItem__timestamp" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDatetime")(
                                          comment.created_at
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ])
                : comment.json && comment.json.type === "RESERVATION_OK"
                ? _c("div", { staticClass: "chatItem" }, [_vm._m(0, true)])
                : comment.json &&
                  comment.json.type === "RESERVATION_OK_WITH_CONSULT"
                ? _c("div", { staticClass: "chatItem" }, [_vm._m(1, true)])
                : comment.json && comment.json.type === "RESERVATION_NG"
                ? _c("div", { staticClass: "chatItem" }, [_vm._m(2, true)])
                : comment.json && comment.json.type === "COMMIT_RESERVATION"
                ? _c("div", { staticClass: "chatItem" }, [
                    _c("div", { staticClass: "chatItem__shopActionResult" }, [
                      _vm._v("仮予約を受付ました。"),
                    ]),
                  ])
                : comment.json && comment.json.type === "EDIT_RESERVATION"
                ? _c("div", { staticClass: "chatItem" }, [
                    _c("div", { staticClass: "chatItem__shopActionResult" }, [
                      _vm._v("予約が変更されました。"),
                    ]),
                  ])
                : comment.json && comment.json.type === "CANCEL_RESERVATION"
                ? _c("div", { staticClass: "chatItem" }, [
                    _c("div", { staticClass: "chatItem__shopActionResult" }, [
                      _vm._v("予約がキャンセルされました。"),
                    ]),
                  ])
                : _c("div", { staticClass: "chatItem" }, [
                    _c(
                      "div",
                      { staticClass: "chatItem__talk chatItem__talk--peer" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "chatItem__talkMainContainer chatItem__talkMainContainer--peer",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "chatItem__balloon chatItem__balloon--peer",
                              },
                              [
                                comment.text
                                  ? _c("div", {
                                      staticClass: "chatItem__text linebreak",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$options.filters.urlize(
                                            comment.text
                                          )
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "chatItem__metaContainer chatItem__metaContainer--peer",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "chatItem__timestamp" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDatetime")(
                                          comment.created_at
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm.banquet
          ? _c(
              "form",
              {
                staticClass: "ui form chatForm",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.postChatComment()
                  },
                },
              },
              [
                _c("div", { staticClass: "field" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.commentForm.model.text,
                        expression: "commentForm.model.text",
                        modifiers: { trim: true },
                      },
                    ],
                    attrs: {
                      rows: "3",
                      disabled: _vm.banquet.status === "requested",
                    },
                    domProps: { value: _vm.commentForm.model.text },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.commentForm.model,
                          "text",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chatForm__actions" },
                  [
                    _c("s3", {
                      attrs: { accept: "image/*,application/pdf" },
                      model: {
                        value: _vm.commentForm.model.attachment,
                        callback: function ($$v) {
                          _vm.$set(_vm.commentForm.model, "attachment", $$v)
                        },
                        expression: "commentForm.model.attachment",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ui primary tiny right floated button",
                        class: { loading: _vm.commentForm.waiting },
                        attrs: {
                          type: "submit",
                          disabled: _vm.banquet.status === "requested",
                        },
                      },
                      [_vm._v("送信する")]
                    ),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.banquet
        ? _c("div", { staticClass: "eight wide column action-column" }, [
            _c("div", { staticClass: "statusContainer" }, [
              _c("h3", [_vm._v("ステータス")]),
              _vm._v(" "),
              _c(
                "table",
                { staticClass: "ui definition keyValueTable table" },
                [
                  _c("tr", [
                    _c("td", [_vm._v("ステータス")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.banquet.status_label) +
                          "  \n              "
                      ),
                      _vm.banquet.status === "requested" ||
                      _vm.banquet.status === "active" ||
                      _vm.banquet.status === "ng"
                        ? _c(
                            "button",
                            {
                              staticClass: "ui tiny orange button",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.openReplyDialog()
                                },
                              },
                            },
                            [_vm._v("空席の有無を変更する")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-top": "12px" } }, [
                        _vm.banquet.status === "requested" ||
                        _vm.banquet.status === "active" ||
                        _vm.banquet.status === "reserved"
                          ? _c(
                              "button",
                              {
                                staticClass: "ui tiny positive button",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openRegisterContractDialog()
                                  },
                                },
                              },
                              [_vm._v("来店済み")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.banquet.status === "closed"
                          ? _c(
                              "button",
                              {
                                staticClass: "ui tiny positive button",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openContractDialog()
                                  },
                                },
                              },
                              [_vm._v("成約金額を確認する")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.banquet.status === "requested" ||
                        _vm.banquet.status === "active" ||
                        _vm.banquet.status === "ng"
                          ? _c(
                              "button",
                              {
                                staticClass: "ui tiny button",
                                attrs: { type: "button" },
                                on: { click: _vm.cancel },
                              },
                              [_vm._v("成約せず")]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.banquet.status !== "reserved" &&
                  _vm.banquet.status !== "closed"
                    ? _c("tr", [
                        _c("td", [_vm._v("予約承認")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm.banquet.status === "requested" ||
                          _vm.banquet.status === "canceled"
                            ? _c("div", [
                                _vm.banquet.status === "requested"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "ui warning mini message",
                                      },
                                      [
                                        _vm._v(
                                          "「空席あり」のご連絡後に予約承認が可能となります"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "ui green tiny button disabled",
                                  },
                                  [_vm._v("予約承認")]
                                ),
                              ])
                            : _vm.banquet.status === "active"
                            ? _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "ui warning mini message" },
                                  [
                                    _vm._v(
                                      "\n                  お客様から予約希望を受けましたら、予約承認ボタンを押してください。\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "ui green tiny button",
                                    attrs: { type: "button" },
                                    on: { click: _vm.openReserveDialog },
                                  },
                                  [_vm._v("予約承認")]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("tr", [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("td", { staticClass: "linebreak" }, [
                      _vm._v(_vm._s(_vm.banquet.marunage.message_for_shop)),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.banquet.status === "reserved"
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "ui green tiny button",
                        attrs: { type: "button" },
                        on: { click: _vm.openEditReservationDialog },
                      },
                      [_vm._v("予約変更")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ui tiny red button",
                        attrs: { type: "button" },
                        on: { click: _vm.cancel },
                      },
                      [_vm._v("予約をキャンセルする")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("h3", [_vm._v("お客様情報")]),
              _vm._v(" "),
              _c(
                "table",
                { staticClass: "ui definition keyValueTable table" },
                [
                  _c("tr", [
                    _c("td", [_vm._v("会社・団体 / 個人")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.banquet.marunage.is_company
                            ? "会社・団体"
                            : "個人"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.banquet.marunage.is_company
                    ? _c("tr", [
                        _c("td", [_vm._v("会社名・団体名")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.banquet.marunage.company_name)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("お名前(カナ)")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.banquet.marunage.name_kana || "(未設定)")
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("お名前")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.banquet.marunage.name))]),
                  ]),
                  _vm._v(" "),
                  ["active", "reserved", "closed"].includes(_vm.banquet.status)
                    ? [
                        _c("tr", [
                          _c("td", [_vm._v("メールアドレス")]),
                          _vm._v(" "),
                          _vm.banquet.is_email_confirmed
                            ? _c("td", [
                                _c("span", [_vm._v("※メールアドレス確認済み")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ui positive large message",
                                    staticStyle: { "margin-top": "0" },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.banquet.marunage.email ||
                                            "(未設定)"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "ui orange button",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openEMailDialog()
                                      },
                                    },
                                  },
                                  [_vm._v("メールアドレスを確認する")]
                                ),
                              ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("電話番号")]),
                          _vm._v(" "),
                          _vm.banquet.is_tel_confirmed
                            ? _c("td", [
                                _c("span", [_vm._v("※電話番号確認済み")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ui positive large message",
                                    staticStyle: { "margin-top": "0" },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.banquet.marunage.tel || "(未設定)"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "ui orange button",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openTelDialog()
                                      },
                                    },
                                  },
                                  [_vm._v("電話番号を確認する")]
                                ),
                              ]),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("h3", [_vm._v("宴会情報")]),
              _vm._v(" "),
              _c(
                "table",
                { staticClass: "ui definition keyValueTable table" },
                [
                  _c("tr", [
                    _c("td", [_vm._v("利用カテゴリ")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.banquet.marunage.category_label)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("利用主旨")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.banquet.marunage.purpose))]),
                  ]),
                  _vm._v(" "),
                  _vm.banquet.reservation
                    ? _c("tr", [
                        _c("td", [_vm._v("予約日時")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("formatDate")(
                                  _vm.banquet.reservation.event_date
                                )
                              ) +
                              " " +
                              _vm._s(_vm.banquet.reservation.event_time) +
                              "\n            "
                          ),
                        ]),
                      ])
                    : _c("tr", [
                        _c("td", [_vm._v("利用日時")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDate")(
                                _vm.banquet.marunage.event_date
                              )
                            ) +
                              " " +
                              _vm._s(_vm.banquet.marunage.event_time)
                          ),
                        ]),
                      ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("日時の変更可否")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.banquet.marunage.is_event_datatime_flexible
                            ? "（可）"
                            : "（不可）"
                        ) +
                          " " +
                          _vm._s(_vm.banquet.marunage.event_datetime_memo)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.banquet.reservation
                    ? _c("tr", [
                        _c("td", [_vm._v("予約人数")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.banquet.reservation.detail_people) + "人"
                          ),
                        ]),
                      ])
                    : _c("tr", [
                        _c("td", [_vm._v("人数")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.banquet.marunage.people_label)),
                        ]),
                      ]),
                  _vm._v(" "),
                  _vm.banquet.reservation
                    ? _c("tr", [
                        _c("td", [_vm._v("1人あたりの料金")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatCurrency")(
                                _vm.banquet.reservation.detail_price
                              )
                            ) + "円"
                          ),
                        ]),
                      ])
                    : _c("tr", [
                        _c("td", [_vm._v("1人あたりの予算")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.banquet.marunage.price_label)),
                        ]),
                      ]),
                  _vm._v(" "),
                  _vm.banquet.reservation && _vm.banquet.reservation.course
                    ? _c("tr", [
                        _c("td", [_vm._v("プラン")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.banquet.reservation.course.name)),
                        ]),
                      ])
                    : !_vm.banquet.reservation && _vm.banquet.course
                    ? _c("tr", [
                        _c("td", [_vm._v("希望プラン")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.banquet.course.name))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.banquet.reservation && _vm.banquet.reservation.meeting
                    ? _c("tr", [
                        _c("td", [_vm._v("プラン")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.banquet.reservation.meeting.name)),
                        ]),
                      ])
                    : !_vm.banquet.reservation && _vm.banquet.meeting
                    ? _c("tr", [
                        _c("td", [_vm._v("希望プラン")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.banquet.meeting.name))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.banquet.reservation &&
                  _vm.banquet.reservation.lodge_meeting
                    ? _c("tr", [
                        _c("td", [_vm._v("プラン")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.banquet.reservation.lodge_meeting.name)
                          ),
                        ]),
                      ])
                    : !_vm.banquet.reservation && _vm.banquet.lodge_meeting
                    ? _c("tr", [
                        _c("td", [_vm._v("希望プラン")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.banquet.lodge_meeting.name)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("予算の変更可否")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.banquet.marunage.is_price_flexible
                            ? "（可）"
                            : "（不可）"
                        ) +
                          " " +
                          _vm._s(_vm.banquet.marunage.price_memo)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("立食・着席希望")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.banquet.marunage.seat_preference_label)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("会議室のご利用")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.banquet.marunage.use_meeting_room_label)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("設備・サービス")]),
                    _vm._v(" "),
                    _vm.banquet.marunage.use_facilities.length > 0 &&
                    _vm.banquet.marunage.use_facilities_memo
                      ? _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.banquet.marunage.use_facilities.join("、")
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            _vm._s(_vm.banquet.marunage.use_facilities_memo) +
                              "\n            "
                          ),
                        ])
                      : _vm.banquet.marunage.use_facilities.length > 0
                      ? _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.banquet.marunage.use_facilities.join("、")
                              ) +
                              "\n            "
                          ),
                        ])
                      : _vm.banquet.marunage.use_facilities_memo
                      ? _c("td", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.banquet.marunage.use_facilities_memo) +
                              "\n            "
                          ),
                        ])
                      : _c("td", [
                          _vm._v("\n              (未設定)\n            "),
                        ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("その他希望条件")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.banquet.marunage.note || "(未設定)")),
                    ]),
                  ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui small modal", attrs: { id: "reply-dialog" } },
      [
        _c("i", { staticClass: "close icon" }),
        _vm._v(" "),
        _c("div", { staticClass: "header" }, [_vm._v("空席の有無を連絡する")]),
        _vm._v(" "),
        _c("div", { staticClass: "scrolling content" }, [
          _vm.banquet
            ? _c(
                "table",
                { staticClass: "ui definition keyValueTable table replyTable" },
                [
                  _c("tr", [
                    _c("td", [_vm._v("ステータス")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.banquet.status_label))]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("区分")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.banquet.marunage.is_company
                            ? "会社・団体"
                            : "個人"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.banquet.marunage.is_company
                    ? _c("tr", [
                        _c("td", [_vm._v("会社名・団体名")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.banquet.marunage.company_name)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("お名前")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.banquet.marunage.name || "(未設定)")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("お名前(カナ)")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.banquet.marunage.name_kana || "(未設定)")
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.banquet
            ? _c(
                "table",
                { staticClass: "ui definition keyValueTable table replyTable" },
                [
                  _c("tr", [
                    _c("td", [_vm._v("利用カテゴリ")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.banquet.marunage.category_label)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("利用主旨")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.banquet.marunage.purpose))]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("希望日時")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm._f("formatDate")(_vm.banquet.marunage.event_date)
                        ) +
                          " " +
                          _vm._s(_vm.banquet.marunage.event_time)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("日時の変更可否")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.banquet.marunage.is_event_datatime_flexible
                            ? "（可）"
                            : "（不可）"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("日時の変更可否：コメント")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.banquet.marunage.event_datetime_memo || "(未設定)"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("人数")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.banquet.marunage.people_label)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("立食・着席希望")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.banquet.marunage.seat_preference_label)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("会議室のご利用")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.banquet.marunage.use_meeting_room_label)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("一人当たりの予算")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.banquet.marunage.price_label)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("予算の変更可否")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.banquet.marunage.is_price_flexible
                            ? "（可）"
                            : "（不可）"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("予算の変更可否：コメント")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.banquet.marunage.price_memo || "(未設定)")
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.banquet.course
                    ? _c("tr", [
                        _c("td", [_vm._v("希望プラン")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.banquet.course.name))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.banquet.meeting
                    ? _c("tr", [
                        _c("td", [_vm._v("希望プラン")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.banquet.meeting.name))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.banquet.lodge_meeting
                    ? _c("tr", [
                        _c("td", [_vm._v("希望プラン")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.banquet.lodge_meeting.name)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("設備・サービス")]),
                    _vm._v(" "),
                    _vm.banquet.marunage.use_facilities.length
                      ? _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.banquet.marunage.use_facilities.join("、")
                            )
                          ),
                        ])
                      : _c("td", [_vm._v("(未設定)")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("希望条件など")]),
                    _vm._v(" "),
                    _c("td", { staticClass: "linebreak" }, [
                      _vm._v(_vm._s(_vm.banquet.marunage.note)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("td", { staticClass: "linebreak" }, [
                      _vm._v(_vm._s(_vm.banquet.marunage.message_for_shop)),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "ui clearing divider" }),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "ui form replyTemplateForm",
              class: { warning: _vm.replyForm.hasError() },
            },
            [
              _c(
                "div",
                { staticClass: "required field" },
                [
                  _c("label", [_vm._v("空席状況")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui checkbox radio" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.replyForm.model.accept_type,
                          expression: "replyForm.model.accept_type",
                        },
                      ],
                      attrs: { type: "radio", value: "OK" },
                      domProps: {
                        checked: _vm._q(_vm.replyForm.model.accept_type, "OK"),
                      },
                      on: {
                        change: [
                          function ($event) {
                            return _vm.$set(
                              _vm.replyForm.model,
                              "accept_type",
                              "OK"
                            )
                          },
                          _vm.changeAccept,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("空席あり")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui checkbox radio" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.replyForm.model.accept_type,
                          expression: "replyForm.model.accept_type",
                        },
                      ],
                      attrs: { type: "radio", value: "OK_WITH_CONSULT" },
                      domProps: {
                        checked: _vm._q(
                          _vm.replyForm.model.accept_type,
                          "OK_WITH_CONSULT"
                        ),
                      },
                      on: {
                        change: [
                          function ($event) {
                            return _vm.$set(
                              _vm.replyForm.model,
                              "accept_type",
                              "OK_WITH_CONSULT"
                            )
                          },
                          _vm.changeAccept,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("空席あり（要相談）")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui checkbox radio" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.replyForm.model.accept_type,
                          expression: "replyForm.model.accept_type",
                        },
                      ],
                      attrs: { type: "radio", value: "NG" },
                      domProps: {
                        checked: _vm._q(_vm.replyForm.model.accept_type, "NG"),
                      },
                      on: {
                        change: [
                          function ($event) {
                            return _vm.$set(
                              _vm.replyForm.model,
                              "accept_type",
                              "NG"
                            )
                          },
                          _vm.changeAccept,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("空席なし")]),
                  ]),
                  _vm._v(" "),
                  _c("validation-message", {
                    attrs: { form: _vm.replyForm, field: "accept_type" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field" },
                [
                  _vm._m(5),
                  _vm._v(" "),
                  _c(
                    "dropdown",
                    {
                      attrs: { placeholder: "指定しない" },
                      on: {
                        change: function ($event) {
                          return _vm.onReplyTemplateChange()
                        },
                      },
                      model: {
                        value: _vm.replyForm.model.reply_template_id,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.replyForm.model,
                            "reply_template_id",
                            $$v
                          )
                        },
                        expression: "replyForm.model.reply_template_id",
                      },
                    },
                    [
                      _c("option", { attrs: { value: "" } }),
                      _vm._v(" "),
                      _vm._l(_vm.reply_templates, function (each) {
                        return _c(
                          "option",
                          { key: each.id, domProps: { value: each.id } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(each.name) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "required field" },
                [
                  _c("label", [_vm._v("メッセージ")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.replyForm.model.message,
                        expression: "replyForm.model.message",
                      },
                    ],
                    attrs: {
                      type: "text",
                      rows: "5",
                      placeholder: _vm.replyMessagePlaceholder,
                    },
                    domProps: { value: _vm.replyForm.model.message },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.replyForm.model,
                          "message",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("validation-message", {
                    attrs: { form: _vm.replyForm, field: "message" },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _c("div", { staticClass: "ui cancel button" }, [_vm._v("閉じる")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ui green button",
              class: { "loading disabled": _vm.replyForm.waiting },
              on: {
                click: function ($event) {
                  return _vm.reply()
                },
              },
            },
            [_vm._v("送信する")]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui tiny modal", attrs: { id: "reserve-dialog" } },
      [
        _c("i", { staticClass: "close icon" }),
        _vm._v(" "),
        _c("div", { staticClass: "header" }, [
          _vm._v("予約情報を入力してください"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "scrolling content",
            staticStyle: { "min-height": "400px" },
          },
          [
            _c(
              "form",
              {
                staticClass: "ui form",
                class: { warning: _vm.reserveForm.hasErrors() },
              },
              [
                _c("div", { staticClass: "two fields" }, [
                  _c(
                    "div",
                    { staticClass: "required field" },
                    [
                      _c("label", [_vm._v("希望日")]),
                      _vm._v(" "),
                      _c("datepick", {
                        attrs: { from: 1, placeholder: "希望日" },
                        model: {
                          value: _vm.reserveForm.model.event_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.reserveForm.model, "event_date", $$v)
                          },
                          expression: "reserveForm.model.event_date",
                        },
                      }),
                      _vm._v(" "),
                      _c("validation-message", {
                        attrs: { form: _vm.reserveForm, field: "event_date" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "required field" },
                    [
                      _c("label", [_vm._v("希望時間")]),
                      _vm._v(" "),
                      _c("dropdown", {
                        attrs: {
                          options: _vm.consts.MARUNAGE_EVENT_TIME,
                          placeholder: "希望時間",
                        },
                        model: {
                          value: _vm.reserveForm.model.event_time,
                          callback: function ($$v) {
                            _vm.$set(_vm.reserveForm.model, "event_time", $$v)
                          },
                          expression: "reserveForm.model.event_time",
                        },
                      }),
                      _vm._v(" "),
                      _c("validation-message", {
                        attrs: { form: _vm.reserveForm, field: "event_time" },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _vm.canChoosePlan
                    ? _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                        _vm.banquet.shop && _vm.banquet.shop.courses.length > 0
                          ? _c("div", { staticClass: "ui checkbox radio" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedPlanType,
                                    expression: "selectedPlanType",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "courses",
                                  name: "plan_type",
                                },
                                domProps: {
                                  value: _vm.consts.PLAN_TYPE_TO_VALUE.course,
                                  checked: _vm._q(
                                    _vm.selectedPlanType,
                                    _vm.consts.PLAN_TYPE_TO_VALUE.course
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.selectedPlanType =
                                      _vm.consts.PLAN_TYPE_TO_VALUE.course
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { for: "courses" },
                                },
                                [_vm._v("宴会")]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.banquet.shop && _vm.banquet.shop.meetings.length > 0
                          ? _c("div", { staticClass: "ui checkbox radio" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedPlanType,
                                    expression: "selectedPlanType",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "meetings",
                                  name: "plan_type",
                                },
                                domProps: {
                                  value: _vm.consts.PLAN_TYPE_TO_VALUE.meeting,
                                  checked: _vm._q(
                                    _vm.selectedPlanType,
                                    _vm.consts.PLAN_TYPE_TO_VALUE.meeting
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.selectedPlanType =
                                      _vm.consts.PLAN_TYPE_TO_VALUE.meeting
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { for: "meetings" },
                                },
                                [_vm._v("会議室")]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.banquet.shop &&
                        _vm.banquet.shop.lodge_meetings.length > 0
                          ? _c("div", { staticClass: "ui checkbox radio" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedPlanType,
                                    expression: "selectedPlanType",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "lodge-meetings",
                                  name: "plan_type",
                                },
                                domProps: {
                                  value:
                                    _vm.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting,
                                  checked: _vm._q(
                                    _vm.selectedPlanType,
                                    _vm.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.selectedPlanType =
                                      _vm.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { for: "lodge-meetings" },
                                },
                                [_vm._v("宿泊会議")]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedPlanType === _vm.consts.PLAN_TYPE_TO_VALUE.course
                    ? _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "dropdown",
                            {
                              attrs: { placeholder: "プラン" },
                              model: {
                                value: _vm.reserveForm.model.course_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.reserveForm.model,
                                    "course_id",
                                    $$v
                                  )
                                },
                                expression: "reserveForm.model.course_id",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("-----"),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.banquet.shop.courses,
                                function (course) {
                                  return _c(
                                    "option",
                                    {
                                      key:
                                        _vm.consts.PLAN_TYPE_TO_VALUE.course +
                                        course.id,
                                      domProps: { value: course.id },
                                    },
                                    [_vm._v(_vm._s(course.name))]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("validation-message", {
                            attrs: {
                              form: _vm.reserveForm,
                              field: "course_id",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedPlanType === _vm.consts.PLAN_TYPE_TO_VALUE.meeting
                    ? _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "dropdown",
                            {
                              attrs: { placeholder: "プラン" },
                              model: {
                                value: _vm.reserveForm.model.meeting_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.reserveForm.model,
                                    "meeting_id",
                                    $$v
                                  )
                                },
                                expression: "reserveForm.model.meeting_id",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("-----"),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.banquet.shop.meetings,
                                function (meeting) {
                                  return _c(
                                    "option",
                                    {
                                      key:
                                        _vm.consts.PLAN_TYPE_TO_VALUE.meeting +
                                        meeting.id,
                                      domProps: { value: meeting.id },
                                    },
                                    [_vm._v(_vm._s(meeting.name))]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("validation-message", {
                            attrs: {
                              form: _vm.reserveForm,
                              field: "meeting_id",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedPlanType ===
                  _vm.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting
                    ? _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "dropdown",
                            {
                              attrs: { placeholder: "プラン" },
                              model: {
                                value: _vm.reserveForm.model.lodge_meeting_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.reserveForm.model,
                                    "lodge_meeting_id",
                                    $$v
                                  )
                                },
                                expression:
                                  "reserveForm.model.lodge_meeting_id",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("-----"),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.banquet.shop.lodge_meetings,
                                function (lodgeMeeting) {
                                  return _c(
                                    "option",
                                    {
                                      key:
                                        _vm.consts.PLAN_TYPE_TO_VALUE
                                          .lodgeMeeting + lodgeMeeting.id,
                                      domProps: { value: lodgeMeeting.id },
                                    },
                                    [_vm._v(_vm._s(lodgeMeeting.name))]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("validation-message", {
                            attrs: {
                              form: _vm.reserveForm,
                              field: "lodge_meeting_id",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "two fields" }, [
                  _c(
                    "div",
                    { staticClass: "required field" },
                    [
                      _c("label", [_vm._v("一人当たりの料金")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.reserveForm.model.detail_price,
                            expression: "reserveForm.model.detail_price",
                          },
                        ],
                        attrs: {
                          type: "number",
                          placeholder: "一人当たりの料金",
                        },
                        domProps: { value: _vm.reserveForm.model.detail_price },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.reserveForm.model,
                              "detail_price",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("validation-message", {
                        attrs: { form: _vm.reserveForm, field: "detail_price" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "required field" },
                    [
                      _c("label", [_vm._v("予約人数")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.reserveForm.model.detail_people,
                            expression: "reserveForm.model.detail_people",
                          },
                        ],
                        attrs: { type: "number", placeholder: "予約人数" },
                        domProps: {
                          value: _vm.reserveForm.model.detail_people,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.reserveForm.model,
                              "detail_people",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("validation-message", {
                        attrs: {
                          form: _vm.reserveForm,
                          field: "detail_people",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ui positive message" }, [
              _vm._v(
                "お客様から日程変更の連絡を受けた場合は、本管理画面にて日程を再設定してください。"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _c("div", { staticClass: "ui cancel button" }, [_vm._v("閉じる")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ui green button",
              class: { "loading disabled": _vm.reserveForm.waiting },
              on: { click: _vm.reserve },
            },
            [_vm._v("予約承認")]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ui tiny modal",
        attrs: { id: "edit-reservation-dialog" },
      },
      [
        _c("i", { staticClass: "close icon" }),
        _vm._v(" "),
        _c("div", { staticClass: "header" }, [
          _vm._v("予約情報を入力してください"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "scrolling content",
            staticStyle: { "min-height": "400px" },
          },
          [
            _c(
              "form",
              {
                staticClass: "ui form",
                class: { warning: _vm.reserveForm.hasErrors() },
              },
              [
                _c("div", { staticClass: "two fields" }, [
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", [_vm._v("希望日")]),
                      _vm._v(" "),
                      _c("datepick", {
                        attrs: { from: 1, placeholder: "希望日" },
                        model: {
                          value: _vm.reserveForm.model.event_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.reserveForm.model, "event_date", $$v)
                          },
                          expression: "reserveForm.model.event_date",
                        },
                      }),
                      _vm._v(" "),
                      _c("validation-message", {
                        attrs: { form: _vm.reserveForm, field: "event_date" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", [_vm._v("希望時間")]),
                      _vm._v(" "),
                      _c("dropdown", {
                        attrs: {
                          options: _vm.consts.MARUNAGE_EVENT_TIME,
                          placeholder: "希望時間",
                        },
                        model: {
                          value: _vm.reserveForm.model.event_time,
                          callback: function ($$v) {
                            _vm.$set(_vm.reserveForm.model, "event_time", $$v)
                          },
                          expression: "reserveForm.model.event_time",
                        },
                      }),
                      _vm._v(" "),
                      _c("validation-message", {
                        attrs: { form: _vm.reserveForm, field: "event_time" },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("label", [_vm._v("プラン")]),
                  _vm._v(" "),
                  _vm.canChoosePlan
                    ? _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                        _vm.banquet.shop && _vm.banquet.shop.courses.length > 0
                          ? _c("div", { staticClass: "ui checkbox radio" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedPlanType,
                                    expression: "selectedPlanType",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "courses",
                                  name: "plan_type",
                                },
                                domProps: {
                                  value: _vm.consts.PLAN_TYPE_TO_VALUE.course,
                                  checked: _vm._q(
                                    _vm.selectedPlanType,
                                    _vm.consts.PLAN_TYPE_TO_VALUE.course
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.selectedPlanType =
                                      _vm.consts.PLAN_TYPE_TO_VALUE.course
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { for: "courses" },
                                },
                                [_vm._v("宴会")]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.banquet.shop && _vm.banquet.shop.meetings.length > 0
                          ? _c("div", { staticClass: "ui checkbox radio" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedPlanType,
                                    expression: "selectedPlanType",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "meetings",
                                  name: "plan_type",
                                },
                                domProps: {
                                  value: _vm.consts.PLAN_TYPE_TO_VALUE.meeting,
                                  checked: _vm._q(
                                    _vm.selectedPlanType,
                                    _vm.consts.PLAN_TYPE_TO_VALUE.meeting
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.selectedPlanType =
                                      _vm.consts.PLAN_TYPE_TO_VALUE.meeting
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { for: "meetings" },
                                },
                                [_vm._v("会議室")]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.banquet.shop &&
                        _vm.banquet.shop.lodge_meetings.length > 0
                          ? _c("div", { staticClass: "ui checkbox radio" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedPlanType,
                                    expression: "selectedPlanType",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "lodge-meetings",
                                  name: "plan_type",
                                },
                                domProps: {
                                  value:
                                    _vm.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting,
                                  checked: _vm._q(
                                    _vm.selectedPlanType,
                                    _vm.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.selectedPlanType =
                                      _vm.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { for: "lodge-meetings" },
                                },
                                [_vm._v("宿泊会議")]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedPlanType === _vm.consts.PLAN_TYPE_TO_VALUE.course
                    ? _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "dropdown",
                            {
                              attrs: { placeholder: "プラン" },
                              model: {
                                value: _vm.reserveForm.model.course_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.reserveForm.model,
                                    "course_id",
                                    $$v
                                  )
                                },
                                expression: "reserveForm.model.course_id",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("-----"),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.banquet.shop.courses,
                                function (course) {
                                  return _c(
                                    "option",
                                    {
                                      key:
                                        _vm.consts.PLAN_TYPE_TO_VALUE.course +
                                        course.id,
                                      domProps: { value: course.id },
                                    },
                                    [_vm._v(_vm._s(course.name))]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("validation-message", {
                            attrs: {
                              form: _vm.reserveForm,
                              field: "course_id",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedPlanType === _vm.consts.PLAN_TYPE_TO_VALUE.meeting
                    ? _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "dropdown",
                            {
                              attrs: { placeholder: "プラン" },
                              model: {
                                value: _vm.reserveForm.model.meeting_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.reserveForm.model,
                                    "meeting_id",
                                    $$v
                                  )
                                },
                                expression: "reserveForm.model.meeting_id",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("-----"),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.banquet.shop.meetings,
                                function (meeting) {
                                  return _c(
                                    "option",
                                    {
                                      key:
                                        _vm.consts.PLAN_TYPE_TO_VALUE.meeting +
                                        meeting.id,
                                      domProps: { value: meeting.id },
                                    },
                                    [_vm._v(_vm._s(meeting.name))]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("validation-message", {
                            attrs: {
                              form: _vm.reserveForm,
                              field: "meeting_id",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedPlanType ===
                  _vm.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting
                    ? _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "dropdown",
                            {
                              attrs: { placeholder: "プラン" },
                              model: {
                                value: _vm.reserveForm.model.lodge_meeting_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.reserveForm.model,
                                    "lodge_meeting_id",
                                    $$v
                                  )
                                },
                                expression:
                                  "reserveForm.model.lodge_meeting_id",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("-----"),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.banquet.shop.lodge_meetings,
                                function (lodgeMeeting) {
                                  return _c(
                                    "option",
                                    {
                                      key:
                                        _vm.consts.PLAN_TYPE_TO_VALUE
                                          .lodgeMeeting + lodgeMeeting.id,
                                      domProps: { value: lodgeMeeting.id },
                                    },
                                    [_vm._v(_vm._s(lodgeMeeting.name))]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("validation-message", {
                            attrs: {
                              form: _vm.reserveForm,
                              field: "lodge_meeting_id",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "two fields" }, [
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", [_vm._v("一人当たりの料金")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.reserveForm.model.detail_price,
                            expression: "reserveForm.model.detail_price",
                          },
                        ],
                        attrs: {
                          type: "number",
                          placeholder: "一人当たりの料金",
                        },
                        domProps: { value: _vm.reserveForm.model.detail_price },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.reserveForm.model,
                              "detail_price",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("validation-message", {
                        attrs: { form: _vm.reserveForm, field: "detail_price" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", [_vm._v("予約人数")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.reserveForm.model.detail_people,
                            expression: "reserveForm.model.detail_people",
                          },
                        ],
                        attrs: { type: "number", placeholder: "予約人数" },
                        domProps: {
                          value: _vm.reserveForm.model.detail_people,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.reserveForm.model,
                              "detail_people",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("validation-message", {
                        attrs: {
                          form: _vm.reserveForm,
                          field: "detail_people",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _c("div", { staticClass: "ui cancel button" }, [_vm._v("閉じる")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ui green button",
              class: { "loading disabled": _vm.reserveForm.waiting },
              on: { click: _vm.editReservation },
            },
            [_vm._v("予約情報を変更する")]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ui small modal",
        attrs: { id: "register-contract-dialog" },
      },
      [
        _c("i", { staticClass: "close icon" }),
        _vm._v(" "),
        _c("div", { staticClass: "header" }, [
          _vm._v("来店確認・成約金額登録"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "scrolling content",
            staticStyle: { "min-height": "400px" },
          },
          [
            _vm._m(7),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "ui form contractForm",
                class: { warning: _vm.registerContractForm.hasErrors() },
              },
              [
                _vm._m(8),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "two fields",
                    staticStyle: { "flex-wrap": "nowrap" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "required field" },
                      [
                        _c("label", [_vm._v("実施日")]),
                        _vm._v(" "),
                        _c("datepick", {
                          attrs: { placeholder: "実施日" },
                          model: {
                            value: _vm.registerContractForm.model.event_date,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.registerContractForm.model,
                                "event_date",
                                $$v
                              )
                            },
                            expression: "registerContractForm.model.event_date",
                          },
                        }),
                        _vm._v(" "),
                        _c("validation-message", {
                          attrs: {
                            form: _vm.registerContractForm,
                            field: "event_date",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "required field" },
                      [
                        _c("label", [_vm._v("実施時間")]),
                        _vm._v(" "),
                        _c("dropdown", {
                          attrs: {
                            options: _vm.consts.MARUNAGE_EVENT_TIME,
                            placeholder: "実施時間",
                          },
                          model: {
                            value: _vm.registerContractForm.model.event_time,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.registerContractForm.model,
                                "event_time",
                                $$v
                              )
                            },
                            expression: "registerContractForm.model.event_time",
                          },
                        }),
                        _vm._v(" "),
                        _c("validation-message", {
                          attrs: {
                            form: _vm.registerContractForm,
                            field: "event_time",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "two fields",
                    staticStyle: { "flex-wrap": "nowrap" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "required field" },
                      [
                        _c("label", [_vm._v("コース料金(お一人様)")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.registerContractForm.model.detail_price,
                              expression:
                                "registerContractForm.model.detail_price",
                            },
                          ],
                          attrs: {
                            type: "number",
                            placeholder: "コース料金(お一人様)",
                          },
                          domProps: {
                            value: _vm.registerContractForm.model.detail_price,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.registerContractForm.model,
                                "detail_price",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("validation-message", {
                          attrs: {
                            form: _vm.registerContractForm,
                            field: "detail_price",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "required field" },
                      [
                        _c("label", [_vm._v("実施人数")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.registerContractForm.model.detail_people,
                              expression:
                                "registerContractForm.model.detail_people",
                            },
                          ],
                          attrs: { type: "number", placeholder: "実施人数" },
                          domProps: {
                            value: _vm.registerContractForm.model.detail_people,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.registerContractForm.model,
                                "detail_people",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("validation-message", {
                          attrs: {
                            form: _vm.registerContractForm,
                            field: "detail_people",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "required eight wide field" }, [
                  _c("label", [_vm._v("コース料金総額(税込)")]),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "text",
                      placeholder: "コース料金総額(税込)",
                      disabled: "",
                    },
                    domProps: { value: _vm.totalCoursePrice.toLocaleString() },
                  }),
                ]),
                _vm._v(" "),
                _vm._m(9),
                _vm._v(" "),
                _vm._l(
                  _vm.registerContractForm.model.optional_items,
                  function (item, index) {
                    return _c("div", { key: index, staticClass: "fields" }, [
                      _c(
                        "div",
                        { staticClass: "field seven wide" },
                        [
                          _c(
                            "label",
                            {
                              class: {
                                contractForm__optionalInputLabel: index !== 0,
                              },
                            },
                            [_vm._v("項目")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.name,
                                expression: "item.name",
                              },
                            ],
                            staticClass: "contractForm__OptionalInputField",
                            attrs: {
                              type: "text",
                              placeholder: "マイク利用貸与料金",
                            },
                            domProps: { value: item.name },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(item, "name", $event.target.value)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("validation-message", {
                            attrs: {
                              form: _vm.registerContractForm,
                              field: "optional_items",
                              subField: "name",
                              index: index,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field seven wide" },
                        [
                          _c(
                            "label",
                            {
                              class: {
                                contractForm__optionalInputLabel: index !== 0,
                              },
                            },
                            [_vm._v("金額")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.price,
                                expression: "item.price",
                              },
                            ],
                            staticClass: "contractForm__OptionalInputField",
                            attrs: { type: "number", placeholder: "10,000" },
                            domProps: { value: item.price },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(item, "price", $event.target.value)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("validation-message", {
                            attrs: {
                              form: _vm.registerContractForm,
                              field: "optional_items",
                              subField: "price",
                              index: index,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      index !== 0 &&
                      _vm.registerContractForm.model.optional_items.length -
                        1 ===
                        index
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "field contractForm__optionalButtonContainer pcOnly",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "ui tiny red button icon",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeOtherItem(index)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "trash alternate outline icon",
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  }
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "field fourteen wide contractForm__optionalButtonContainer pcOnly",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "ui button icon",
                        attrs: { type: "button" },
                        on: { click: _vm.addOtherItem },
                      },
                      [
                        _c("i", { staticClass: "clickable plus icon" }),
                        _vm._v(" 追加する\n          "),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "field contractForm__optionalButtonContainerMobile spOnly",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "ui tiny button icon",
                        attrs: { type: "button" },
                        on: { click: _vm.addOtherItem },
                      },
                      [
                        _c("i", { staticClass: "clickable plus icon" }),
                        _vm._v(" 追加する\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.registerContractForm.model.optional_items.length > 1
                      ? _c(
                          "button",
                          {
                            staticClass: "ui tiny red button icon",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.removeOtherItem(_vm.index)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "trash alternate outline icon",
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "two fields" }, [
                  _c("div", { staticClass: "required field eight wide" }, [
                    _c("label", [_vm._v("お支払い総額計(税込)")]),
                    _vm._v(" "),
                    _c("input", {
                      attrs: {
                        type: "text",
                        placeholder: "お支払い総額計(税込)",
                        disabled: "",
                      },
                      domProps: { value: _vm.totalPrice.toLocaleString() },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "fields" }, [
                  _c(
                    "div",
                    { staticClass: "required field sixteen wide" },
                    [
                      _c("p", [
                        _vm._v(
                          "レシート、もしくは金額の内容がわかるものを添付ください。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("s3", {
                        attrs: { accept: "image/*,application/pdf" },
                        model: {
                          value: _vm.registerContractForm.model.receipt_image,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.registerContractForm.model,
                              "receipt_image",
                              $$v
                            )
                          },
                          expression:
                            "registerContractForm.model.receipt_image",
                        },
                      }),
                      _vm._v(" "),
                      _c("validation-message", {
                        attrs: {
                          form: _vm.registerContractForm,
                          field: "receipt_image",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-top": "5px" } }, [
                        _vm._v("※JPEG、PNG、PDFのみ"),
                      ]),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _vm._m(11),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _c("div", { staticClass: "ui cancel button" }, [_vm._v("閉じる")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ui green button",
              class: { "loading disabled": _vm.registerContractForm.waiting },
              on: { click: _vm.registerContract },
            },
            [_vm._v("金額を登録する")]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui small modal", attrs: { id: "contract-dialog" } },
      [
        _c("i", { staticClass: "close icon" }),
        _vm._v(" "),
        _c("div", { staticClass: "header" }, [
          _vm._v("来店確認・成約金額登録"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "scrolling content",
            staticStyle: { "min-height": "400px" },
          },
          [
            _vm.contract
              ? _c(
                  "form",
                  { staticClass: "ui form contractForm" },
                  [
                    _vm._m(12),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "two fields",
                        staticStyle: { "flex-wrap": "nowrap" },
                      },
                      [
                        _c("div", { staticClass: "required field" }, [
                          _c("label", [_vm._v("実施日")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "contractForm__viewContent" },
                            [
                              _vm._v(
                                _vm._s(_vm.contract.event_date.toLocaleString())
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "required field" }, [
                          _c("label", [_vm._v("開始時間")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "contractForm__viewContent" },
                            [_vm._v(_vm._s(_vm.contract.event_time))]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "two fields",
                        staticStyle: { "flex-wrap": "nowrap" },
                      },
                      [
                        _c("div", { staticClass: "required field" }, [
                          _c("label", [_vm._v("コース料金(お一人様)")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "contractForm__viewContent" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatCurrency")(
                                    _vm.contract.detail_price
                                  )
                                )
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "required field" }, [
                          _c("label", [_vm._v("実施人数")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "contractForm__viewContent" },
                            [_vm._v(_vm._s(_vm.contract.detail_people))]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "required field" }, [
                      _c("label", [_vm._v("コース料金総額(税込)")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "contractForm__viewContent" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatCurrency")(
                              _vm.contract.total_course_price
                            )
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(13),
                    _vm._v(" "),
                    _vm.contract.optional_items.length === 0
                      ? _c("div", { staticClass: "fields" }, [
                          _vm._m(14),
                          _vm._v(" "),
                          _vm._m(15),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.contract.optional_items, function (item, index) {
                      return _c("div", { key: index, staticClass: "fields" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "field seven wide contractForm__OptionalInputField",
                          },
                          [
                            _c("label", [_vm._v("項目")]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "contractForm__viewContent" },
                              [_vm._v(_vm._s(item.name))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "field seven wide contractForm__OptionalInputField",
                          },
                          [
                            _c("label", [_vm._v("金額")]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "contractForm__viewContent" },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("formatCurrency")(item.price))
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "required field sixteen wide",
                        staticStyle: { "margin-top": "40px" },
                      },
                      [
                        _c("label", [_vm._v("お支払い総額計(税込)")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "contractForm__viewContent" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatCurrency")(_vm.contract.total_price)
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(16),
                    _vm._v(" "),
                    _c("div", { staticClass: "fields" }, [
                      _c("div", { staticClass: "field sixteen wide" }, [
                        _c("div", { staticClass: "receiptView" }, [
                          !_vm.contract.receipt_image
                            ? _c(
                                "p",
                                { staticClass: "contractForm__viewContent" },
                                [_vm._v("入力なし")]
                              )
                            : _vm.contract.receipt_image.mime_type ===
                              "application/pdf"
                            ? _c("span", { staticClass: "pdfIcon" }, [
                                _c("i", { staticClass: "fas fa-file-pdf" }),
                              ])
                            : _vm.contract.receipt_image.urls.preview
                            ? _c("img", {
                                attrs: {
                                  src: _vm.contract.receipt_image.urls.preview,
                                },
                              })
                            : _vm.contract.receipt_image.urls.small
                            ? _c("img", {
                                attrs: {
                                  src: _vm.contract.receipt_image.urls.small,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contract.receipt_image
                            ? _c(
                                "span",
                                {
                                  staticClass: "filename",
                                  attrs: {
                                    title:
                                      _vm.contract.receipt_image
                                        .original_file_name,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.contract.receipt_image
                                        .original_file_name
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contract.receipt_image
                            ? _c(
                                "button",
                                {
                                  staticClass: "ui mini negative button",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewReceipt()
                                    },
                                  },
                                },
                                [_vm._v("確認する")]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._m(17),
          ]
        ),
        _vm._v(" "),
        _vm._m(18),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui mini modal", attrs: { id: "dialog-show-email" } },
      [
        _c("i", { staticClass: "close icon" }),
        _vm._v(" "),
        _c("div", { staticClass: "header" }, [_vm._v("メールアドレス")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("p", [_vm._v("※メールアドレス確認済み")]),
          _vm._v(" "),
          _vm.banquet
            ? _c(
                "div",
                { staticClass: "ui positive massive message center aligned" },
                [_c("span", [_vm._v(_vm._s(_vm.banquet.marunage.email))])]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _c("div", { staticClass: "ui button", on: { click: _vm.reload } }, [
            _vm._v("閉じる"),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui mini modal", attrs: { id: "dialog-show-tel" } },
      [
        _c("i", { staticClass: "close icon" }),
        _vm._v(" "),
        _c("div", { staticClass: "header" }, [_vm._v("電話番号")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("p", [_vm._v("※電話番号確認済み")]),
          _vm._v(" "),
          _vm.banquet
            ? _c(
                "div",
                { staticClass: "ui positive massive message center aligned" },
                [_c("span", [_vm._v(_vm._s(_vm.banquet.marunage.tel))])]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _c("div", { staticClass: "ui button", on: { click: _vm.reload } }, [
            _vm._v("閉じる"),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chatItem__shopActionResult" }, [
      _vm._v("\n              [空席あり]"),
      _c("br"),
      _vm._v("\n              お席のご用意が可能です。"),
      _c("br"),
      _vm._v(
        "\n              ご予約は本チャットにてご依頼ください。\n            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chatItem__shopActionResult" }, [
      _vm._v("\n              [空席あり]"),
      _c("br"),
      _vm._v(
        "\n              お席のご用意が可能ですが、会場様とご相談が必要です。"
      ),
      _c("br"),
      _vm._v(
        "\n              条件をこちらのチャットでご確認ください。\n            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chatItem__shopActionResult" }, [
      _vm._v("\n              [空席なし]"),
      _c("br"),
      _vm._v("\n              ご指定の条件ではお席をご用意できません。"),
      _c("br"),
      _vm._v(
        "\n              本チャットにて別な条件で空席の有無をご確認いただけます。\n            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _vm._v("コンシェルジュからの"),
      _c("br"),
      _vm._v("申し送り事項"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _vm._v("コンシェルジュからの"),
      _c("br"),
      _vm._v("申し送り事項"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("返信テンプレート選択（任意）"),
      _c("span", [
        _vm._v("テンプレート登録は"),
        _c("a", { attrs: { href: "/shopadmin/reply_templates" } }, [
          _vm._v("こちら"),
        ]),
        _vm._v("から"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("プラン "),
      _c("small", [
        _vm._v("(特別プランをご提供の場合はプランの選択は必要ありません)"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ui negative message" }, [
      _vm._v("※ご利用金額に応じて、お客様へギフト券をプレゼントしています。"),
      _c("br"),
      _vm._v("正確にご入力をお願いいたします。"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contractForm__contentTitleContainer" }, [
      _c("h3", { staticClass: "contractForm__contentTitle" }, [
        _vm._v("宴会の実施内容"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contractForm__contentTitleContainer" }, [
      _c("h3", { staticClass: "contractForm__contentTitle" }, [
        _vm._v("その他のご利用金額"),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("延長料金、会議利用料、備品などをご入力ください。")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contractForm__contentTitleContainer" }, [
      _c("h3", { staticClass: "contractForm__contentTitle" }, [
        _vm._v("レシート添付"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ui positive message" }, [
      _vm._v(
        "\n        請求に関して不明点がある場合は、以下までご連絡ください。"
      ),
      _c("br"),
      _c("br"),
      _c("br"),
      _vm._v("\n        【グルメプラスサポート（株式会社オールフィット）】"),
      _c("br"),
      _vm._v("\n        メールアドレス：info@gourmetplus.jp"),
      _c("br"),
      _vm._v("\n        電話番号：0422-24-9496\n      "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contractForm__contentTitleContainer" }, [
      _c("h3", { staticClass: "contractForm__contentTitle" }, [
        _vm._v("宴会の実施内容"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contractForm__contentTitleContainer" }, [
      _c("h3", { staticClass: "contractForm__contentTitle" }, [
        _vm._v("その他のご利用金額"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "field seven wide contractForm__OptionalInputField" },
      [_c("label", [_vm._v("項目")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "field seven wide contractForm__OptionalInputField" },
      [_c("label", [_vm._v("金額")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contractForm__contentTitleContainer" }, [
      _c("h3", { staticClass: "contractForm__contentTitle" }, [
        _vm._v("レシート"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ui positive message" }, [
      _vm._v(
        "\n        請求に関して不明点がある場合は、以下までご連絡ください。"
      ),
      _c("br"),
      _c("br"),
      _c("br"),
      _vm._v("\n        【グルメプラスサポート（株式会社オールフィット）】"),
      _c("br"),
      _vm._v("\n        メールアドレス：info@gourmetplus.jp"),
      _c("br"),
      _vm._v("\n        電話番号：0422-24-9496\n      "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "actions" }, [
      _c("div", { staticClass: "ui cancel button" }, [_vm._v("閉じる")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }